import { MobizNotificationPriority } from '../../core';

import { MobizSettingsValue } from './mobiz-settings-value.do';

/**
 * @see mobiz1:Mobiz.Core.Settings.DTO.NotificationSettings
 */
export class NotificationSettings extends MobizSettingsValue {
  EnableEmailNotification: boolean;
  EnableSMSNotification: boolean;
  AllowEnable: MobizNotificationPriority[];
  EnabledNotifications: MobizNotificationPriority[];
}
